import angular from 'angular';
import userAddFormComponent from './user-add-form.component';

export default angular.module('common.components.userAddForm', [])
  .component('userAddForm', userAddFormComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/common/user-add-form/user-add-form.module.js